import { compose, createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './rootReducer';
import { jwt } from './middleware/jwtMiddleware';

const middlewares = [jwt, thunkMiddleware];

// if (__DEV__) {
//   const { createLogger } = require('redux-logger'); // eslint-disable-line global-require
//   const logger = createLogger({ collapsed: true });
//   middlewares.push(logger);
// }

const initialState = {};

const persistConfig = {
  key: 'root',
  storage: storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer)
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  persistedReducer,
  initialState,
  composeEnhancers(
    applyMiddleware(...middlewares)
  ));

let persistor = persistStore(store)

export default { store, persistor }



// WEBPACK FOOTER //
// ./src/redux-modules/store.js